import { saveCallbackStatus } from '@finpay-development/shared-components';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { emptyUser, User } from '../../../security/model/user';
import { UserRole } from '../../../security/model/user-role';
import { Client } from '../../../shared/model/client';
import { GuestParameterInfo } from '../../../guest/models/anonymous-guest';
import { SavingStatus} from '../../../shared/state/saving-status';
import { LogsInfo } from '../../models/log-info';
import { emptyReportFilter, emptyReportInfo, ReportFilter, ReportsInfo } from '../../models/reports-info';
import { getDefaultUserInfo, UserInfo } from '../../models/user-info';
import { emptyUserInfoClient, UserInfoClient } from '../../models/user-info-client';
import { ChannelInfo } from '../../models/channel-payments';
import { UserSearchFormValues,blankUserSearchFormValues } from 'src/admin/components/admin-users/admin-user-search-form';

interface AdminContextState extends SavingStatus {
  userSearch: any; // TODO: don't use any
  logsSearch: any; // TODO: don't use any
  allReports: ReportsInfo[]; // TODO: don't use any
  selectedUser: UserInfo;
  fullUser: User;
  selectedClient: UserInfoClient;
  searchUserForm: Partial<UserSearchFormValues>
  filteredLogs: LogsInfo[] | any;
  filteredReport: ReportsInfo;
  filteredDetailedReport: ReportsInfo;
  reportTypeValues:Array<Object>
  roles: UserRole[];
  clients: Client[];
  userModalForm: {};
  modalSaveStatus: saveCallbackStatus;
  modelErrorMessage: string;
  isLoading: boolean;
  isLoadingCognito: boolean;
  isReportsLoading:boolean;
  isSettlementDetailedLoading: boolean
  clientCheckboxesChecked: Number[];
  facilityCheckboxesChecked: Number[];
  clientAndFacilityData: Client[];
  reportFilters: ReportFilter;
  csvData: Array<Array<string>>;
  patientsNames: string[];
  accountHoldersNames: string[];
  collabIds: string[];
  clientNames: string[];
  facilityNames: string[];
  detailedPatientsNames: string[];
  detailedAccountHoldersNames: string[];
  detailedClientNames: string[];
  detailedFacilityNames: string[];
  usersCsvData: [string[]];
  showDetailModal: boolean;
  isPublicMode: boolean;
  isPublicModeLoggedIn: boolean;
  urlParameters: GuestParameterInfo;
  paymentChannels: ChannelInfo[] | any;
  showLogin: boolean;
  pathName: string;
}

const initialState = {
  userSearch: {
    allUsers: [],
    clientsFilter: [],
    rolesFilter: [],
    facilitiesFilter: [],
  },
  logsSearch: {
    allLogs: [],
  },
  allReports:[],
  filteredUsers: [],
  filteredLogs:[],
  filteredReport: emptyReportInfo,
  filteredDetailedReport: emptyReportInfo,
  reportTypeValues:[],
  selectedUser: getDefaultUserInfo(),
  fullUser: emptyUser,
  selectedClient: emptyUserInfoClient,
  currentFilterUserValues: {},
  currentFilterLogsValues:{},
  currentFilterReportsValues:{},
  roles: [],
  clients: [],
  userModalForm: {},
  modalSaveStatus: saveCallbackStatus.none,
  modelErrorMessage: "",
  isLoading: false,
  isLoadingCognito: false,
  isReportsLoading:false,
  isSettlementDetailedLoading: false,
  clientCheckboxesChecked:[],
  facilityCheckboxesChecked:[],
  clientAndFacilityData: [],
  reportFilters: emptyReportFilter,
  patientsNames: [],
  accountHoldersNames: [],
  clientNames: [],
  collabIds: [],
  facilityNames: [],
  detailedPatientsNames: [],
  detailedAccountHoldersNames: [],
  detailedClientNames: [],
  detailedFacilityNames: [],
  csvData: [], // for 'reports' page
  usersCsvData: [[]], // for 'users' page
  showDetailModal: false,
  isPublicMode: false,
  isPublicModeLoggedIn: false,
  urlParameters: {},
  paymentChannels: [],
  searchUserForm: blankUserSearchFormValues,
  showLogin: false,
  pathName: "",
} as AdminContextState;

const adminSlice = createSlice({
  name: "adminUserContext",
  initialState,
  reducers: {
    clearStatus: (state) => {
      state.modalSaveStatus = saveCallbackStatus.none;
      state.modelErrorMessage = "";
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => { // may not be needed. (unused currently). re-evaluate later
      state.isLoading = action.payload
    },
    resetAdminUserContext() {
      return initialState;
    },
    setIsPublicMode: (state, action) => {
      state.isPublicMode = action.payload;
    },
    setIsPublicModeLoggedIn: (state, action) => {
      state.isPublicModeLoggedIn = action.payload;
    },
    setUrlParameters: (state, action) => {
      state.urlParameters = action.payload;
    },
    setShowLogin: (state, action)=>{
      state.showLogin = action.payload
    },
    setPathName: (state, action)=>{
      state.pathName = action.payload
    }
  },
});

export const {
  resetAdminUserContext,
  setIsPublicMode,
  setIsPublicModeLoggedIn,
  setUrlParameters,
  setShowLogin,
  setPathName
} = adminSlice.actions;
export default adminSlice.reducer;
